// src/components/layout/Footer.tsx
import React from 'react';
import { useTranslation } from 'react-i18next';
import { 
  Facebook, 
  Twitter, 
  Instagram, 
  Linkedin, 
  Github,
  Heart
} from 'lucide-react';
import './Footer.css';

const Footer: React.FC = () => {
  const { t } = useTranslation();
  const currentYear = new Date().getFullYear();

  // const socialLinks = [
  //   { icon: <Facebook size={20} />, href: '#', label: 'Facebook' },
  //   { icon: <Twitter size={20} />, href: '#', label: 'Twitter' },
  //   { icon: <Instagram size={20} />, href: '#', label: 'Instagram' },
  //   { icon: <Linkedin size={20} />, href: '#', label: 'LinkedIn' },
  //   { icon: <Github size={20} />, href: '#', label: 'GitHub' }
  // ];
  const socialLinks = [
    { icon: <Facebook size={20} />, href: '#', label: 'Facebook' }];

  const footerLinks = [
    { label: t('footer.privacy'), href: '#' },
    { label: t('footer.terms'), href: '#' }
  ];

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-brand">
            <div className="footer-logo">
              <span className="logo-text gradient-text">ZZ</span>
              <span className="logo-text">Websites</span>
            </div>
            <p className="footer-tagline">
              Creating digital experiences with <Heart size={16} className="heart-icon" />
            </p>
          </div>

          <div className="footer-social">
            {socialLinks.map((link, index) => (
              <a
                key={index}
                href={link.href}
                className="social-link"
                aria-label={link.label}
                target="_blank"
                rel="noopener noreferrer"
              >
                {link.icon}
              </a>
            ))}
          </div>
        </div>

        <div className="footer-bottom">
          <p className="copyright">
            © {currentYear} ZZ Websites. {t('footer.rights')}.
          </p>
          
          <div className="footer-links">
            {footerLinks.map((link, index) => (
              <React.Fragment key={index}>
                <a href={link.href} className="footer-link">
                  {link.label}
                </a>
                {index < footerLinks.length - 1 && <span className="separator">•</span>}
              </React.Fragment>
            ))}
          </div>
        </div>

        <div className="footer-wave">
          <svg viewBox="0 0 1200 100" preserveAspectRatio="none">
            <path d="M0,50 C150,20 350,80 600,50 C850,20 1050,80 1200,50 L1200,100 L0,100 Z" />
          </svg>
        </div>
      </div>
    </footer>
  );
};

export default Footer;